import { render, staticRenderFns } from "./menuSlider.vue?vue&type=template&id=178ee668&scoped=true&"
import script from "./menuSlider.vue?vue&type=script&lang=js&"
export * from "./menuSlider.vue?vue&type=script&lang=js&"
import style0 from "./menuSlider.vue?vue&type=style&index=0&id=178ee668&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ee668",
  null
  
)

export default component.exports